module.exports = __webpack_public_path__ + "fonts/Rubik-400-cyrillic-ext14.423a58d.woff2";